export default __webpack_public_path__ + "static/05_嘉宾头像_何阳-2fecd289ff64d11c7cce25e50bfb56d9.png";